export default "__VITE_ASSET__95b37d0f__"